/**
 * Job title shown on coach cards (modal + selection).
 * Deloitte candidates see "Career Advisor" instead of "Career Coach".
 */
export function getCoachJobTitle(coach, { t, deloitteUser = false } = {}) {
  if (coach?.isTechSupport) {
    return t('CoachChatList.technical_support', {
      defaultValue: 'Technical Support',
    })
  }
  if (deloitteUser) {
    return t('CoachChatList.career_advisor', {
      defaultValue: 'Career Advisor',
    })
  }
  return t('CoachChatList.career_coach', { defaultValue: 'Career Coach' })
}

/**
 * Section heading for available coaches (Deloitte uses Advisors).
 */
export function getAvailableCoachesHeading(t, { deloitteUser = false } = {}) {
  if (deloitteUser) {
    return t('CoachChatList.available_advisors', {
      defaultValue: 'Available Advisors',
    })
  }
  return t('CoachChatList.available_coaches', {
    defaultValue: 'Available Coaches',
  })
}
